import { Controller } from "@hotwired/stimulus"
import { get } from '../../helpers/request_helpers'

export default class extends Controller {
  static targets = ['anchor', 'template', 'editor']
  static values = { id: Number, url: String }

  #loading = false

  show({ target }) {
    if (!this.urlValue || target.closest('a, button') || this.#loading) return

    this.#appendEditor()
    this.editorTarget.showPopover()
    this.#loadContent()
  }

  close() {
    this.editorTarget.remove()
  }

  async #loadContent() {
    this.#loading = true

    try {
      await get(this.urlValue)
    } catch {
      this.close()
    }

    this.#loading = false
  }

  #appendEditor() {
    const template = this.templateTarget.content.cloneNode(true)
    const anchorName = `--coupon-editor-anchor-${ this.idValue }`

    this.element.appendChild(template)
    this.anchorTarget.style.anchorName = anchorName
    this.editorTarget.style.positionAnchor = anchorName
  }
}
